import { Injectable } from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {BsModalRef} from 'ngx-bootstrap';
import {ModalGenericService} from '../modal-generic/modal-generic.service';

@Injectable()
export class PaymentFailureService {
  bsModalRef: BsModalRef;
  constructor(private route: ActivatedRoute,
              private router: Router,
              private modalGenericService: ModalGenericService, ) { }

  handlePaymentFailure(orderId: any, detail: any, object: any): void {
    // Implementa la logica di fallimento qui
    console.log('Pagamento fallito per l\'ordine: ', detail);

    this.bsModalRef = this.modalGenericService.open(
      {
        closeButton: 'Chiudi',
        message: 'Errore durante la transazione \n' + detail
      }
    );
    this.bsModalRef.content.onClose.subscribe(result => {
      object.dataEmitter.emit(null);
    });


  }
}



// WEBPACK FOOTER //
// ./src/app/shared/paypalButton/payment-failure.service.ts